import React, { useContext, useEffect, useState } from "react";
import Button from "../../../components/shared/button";
import { Outlet } from "react-router-dom";
import AddNewModal from "../../../modals/addNewModal";
import { useTranslation } from "react-i18next";

const ClientInformation = () => {
  const { t } = useTranslation();
  const [isaddnewModelOpen, setisaddnewModelOpen] = useState(false);

  const oAddNewClick = () => {
    setisaddnewModelOpen(true);
  };
 
  return (
    <>
      <div className="main-div py-[55px] flex flex-col gap-[16px]">
        <div className="top flex items-center justify-between gap-[16px]">
          <h5 className="text-blue font-bold">
            {t("dashboard.clientInfoManagement.title")}
          </h5>
          {/* <Button
            text={t("dashboard.clientInfoManagement.addNew")}
            className="button btn-blue !rounded-[29px] medium px-6"
            height={45}
            img="line-md:plus"
            clr="white"
            onClick={oAddNewClick}
          /> */}
        </div>
        <Outlet />
      </div>
      <AddNewModal
        isaddnewModelOpen={isaddnewModelOpen}
        setisaddnewModelOpen={setisaddnewModelOpen}
      />
    </>
  );
};

export default ClientInformation;
